let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("i5Pyj")).then(() => parcelRequire('74uqO'));